<template>
  <div class="d-print-none">
    <v-navigation-drawer
      v-model="drawer"
      class="lighten-3 d-print-none"
      :class="colorName"
      app
    >
      <template v-slot:prepend>
        <changePassowrd>
          <template v-slot:FullName>
            {{ CopManyInfo.FullName }}
          </template>

          <template v-slot:userName>
            User: {{ CopManyInfo.UserName }}
          </template>

          <template v-slot:userType>
            Type: {{ CopManyInfo.UserType }}
          </template>
        </changePassowrd>
      </template>
      <v-divider></v-divider>
      <v-list shaped>
        <div v-for="(item, index) in links" :key="index">
          <v-list-group
            no-action
            v-if="item.hasChild && item.child.length > 0"
            :prepend-icon="item.icon"
            color="green darken-1"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </template>
            <v-list-item
              dense
              v-for="childs in item.child"
              :key="childs.text"
              router
              :to="childs.to"
            >
              <v-list-item-icon>
                <v-icon>{{ childs.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ childs.text }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <!-- the else part  -->
          <v-list-item
            v-else-if="!item.hasChild"
            color="success"
            router
            :to="item.to"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn color="primary" @click="logOut" block>Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar dense app class="lighten-3" :class="colorName">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <span class="headline text-capitalize">{{
          CopManyInfo.companyName
        }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn text>
        <span class="mr-2">User: {{ CopManyInfo.UserName }}</span>
      </v-btn> -->
    </v-app-bar>
  </div>
</template>
<script>
import { tokenMixin } from "../Mixins/tokenMixins.js";
import { mapGetters } from "vuex";
import { EventBus } from "../main.js";
import changePassowrd from "@/components/ChangePassword.vue";
export default {
  components: { changePassowrd },
  mixins: [tokenMixin],
  data() {
    return {
      dialog: false,
      colorName: "grey",
      drawer: false,
      itemSelect: 0,
      group: 0,
      others: [],
    };
  },
  computed: {
    ...mapGetters(["LinksGetter", "GroupGetters"]),
    links() {
      if (this.CopManyInfo.UserType === "Admin") return this.LinksGetter;
      else
        return this.others.filter(eachlink => {
          if (eachlink.hasChild)
            return (eachlink.child = eachlink.child.filter(child => {
              return child.access == true;
            }));
          return eachlink.access == true;
        });
    },
  },
  mounted() {
    EventBus.$on("PrintEvent", val => {
      this.drawer = val;
      // console.log(value);
    });
    this.AccessLinks(this.UserAccesses.ogol);
    // console.log(this.UserAccesses);
    // console.log(this.links);
    // console.log(this.GroupGetters);
    if (
      this.$vuetify.breakpoint.name === "lg" ||
      this.$vuetify.breakpoint.name === "xl"
    )
      this.drawer = true;
    else this.drawer = false;
  },
  methods: {
    logOut() {
      this.$store.commit("OnLogout");
    },
    removeRoutes() {
      // let newRoute = this.GroupGetters
    },
    AccessLinks(values) {
      for (let index = 0; index < this.GroupGetters.length; index++) {
        if (this.GroupGetters[index].hasChild)
          for (
            let index2 = 0;
            index2 < this.GroupGetters[index].child.length;
            index2++
          ) {
            this.GroupGetters[index].child[index2].access = false;
          }
        else this.GroupGetters[index].access = false;
      }

      for (let index = 0; index < values.length; index++) {
        for (let index2 = 0; index2 < this.GroupGetters.length; index2++) {
          if (this.GroupGetters[index2].hasChild) {
            for (
              let Childindex = 0;
              Childindex < this.GroupGetters[index2].child.length;
              Childindex++
            ) {
              if (
                this.GroupGetters[index2].child[Childindex].text ===
                values[index]
              ) {
                this.GroupGetters[index2].child[Childindex].access = true;
              }
            }
          } else {
            if (this.GroupGetters[index2].text === values[index])
              this.GroupGetters[index2].access = true;
          }
        }
      }
      // console.log(this.GroupGetters);
      this.others = this.jsonCopy(this.GroupGetters);
    },
    jsonCopy(src) {
      return JSON.parse(JSON.stringify(src));
    },
  },
};
</script>
